import React from 'react';
import { useTranslation } from 'react-i18next';
import type { EmailIntent } from '../../services/emailHubService';

interface IntentBadgeProps {
  intent: EmailIntent | string | null | undefined;
  confidence?: number | null;
  size?: 'sm' | 'md';
}

const INTENT_COLORS: Record<string, { bg: string; color: string }> = {
  support:     { bg: '#e0f2fe', color: '#0369a1' },
  billing:     { bg: '#fef9c3', color: '#854d0e' },
  feedback:    { bg: '#dcfce7', color: '#166534' },
  partnership: { bg: '#f3e8ff', color: '#7e22ce' },
  abuse:       { bg: '#fee2e2', color: '#991b1b' },
  spam:        { bg: '#f1f5f9', color: '#64748b' },
  general:     { bg: '#e0f2fe', color: '#075985' },
  other:       { bg: '#f1f5f9', color: '#475569' },
};

const DEFAULT_COLOR = { bg: '#f1f5f9', color: '#475569' };

const IntentBadge: React.FC<IntentBadgeProps> = ({ intent, confidence, size = 'md' }) => {
  const { t } = useTranslation('emailHub');

  if (!intent) return null;

  const colors = INTENT_COLORS[intent] ?? DEFAULT_COLOR;
  const label = t(`intents.${intent}`, intent.replace(/_/g, ' '));
  const pct = confidence != null ? Math.round(confidence * 100) : null;

  return (
    <span
      className={`email-hub-intent-badge email-hub-intent-badge--${size}`}
      style={{ backgroundColor: colors.bg, color: colors.color }}
      title={pct != null ? `${label} (${pct}%)` : label}
    >
      {label}
      {pct != null && size === 'md' && (
        <span className="email-hub-intent-badge__pct"> {pct}%</span>
      )}
    </span>
  );
};

export default IntentBadge;
